import { React, useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./Gallery.css";
import { getAllImages } from "../../services/Api";
import IconButton from "@mui/material/IconButton";
// import DeleteIcon from "@mui/icons-material/Delete";
import deleteIcon from "../../images/icons8-delete.svg";

import Card from "../../components/ImageCard/ImageCard";

const Gallery = () => {

  const [searchParams] = useSearchParams();
  
  const uid = searchParams.get("uid") || undefined;
  const username = searchParams.get("username") || undefined;
  const eventid = searchParams.get("eventid") || undefined;
  const eventname = searchParams.get("eventname") || undefined;  
 
  // console.log(searchParams);
  // console.log(uid);

  const initial = {
    uid: "",
    username: "",
    usertype: "",
  };
  const [user, setUser] = useState(initial);
  const [images, setImages] = useState();
  
  const getImages = async () => {
    const data = await getAllImages({uid , eventid});
    // console.log(uid , eventid);
    setImages(data.data.data);
    // console.log(images);
  };
  
  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("user"));
    // console.log(data);
    if (data) setUser(data);

    getImages();
  }, [uid , eventid]);

  return (
    <div className="gallery-container">
      {/* <div className="header">Photo Gallery</div> */}
      <div className="cardcont">
        {uid === undefined && eventid === undefined ? (
          <>
            <div className="heading">
              <span style={{ color: "#ffd900" }}>A</span>ll Images
            </div>
            <div className="image-container">
              {images?.map((elem) => (
                <Card
                  uid={elem.uid}
                  username={elem.username}
                  id={elem.id}
                  url={elem.url}
                  upload_time={elem.upload_time}
                  userId={user?.uid}
                  userType={user?.usertype}
                  voted={elem?.voted}
                  votes={elem?.votes}
                />
              ))}
            </div>
          </>
        ) : (
          ""
        )}
        {uid && uid === user?.uid ? (
          <>
            <div className="heading">
              <span style={{ color: "#ffd900" }}>M</span>y Images
            </div>
            <div className="image-container">
              {images
                ?.filter((elem) => elem.uid === user.uid)
                .map((elem) => (
                  <Card
                    uid={elem.uid}
                    username={elem.username}
                    id={elem.id}
                    url={elem.url}
                    upload_time={elem.upload_time}
                    userId={user?.uid}
                    userType={user?.usertype}
                    voted={elem?.voted}
                    votes={elem?.votes}
                  />
                ))}
            </div>
          </>
        ) : (
          ""
        )}
        {uid && uid !== user?.uid ? (
          <>
            <div className="heading">{`${username}`}'s Images</div>
            <div className="image-container">
              {images
                ?.filter((elem) => elem.uid === uid)
                .map((elem) => (
                  <Card
                    uid={elem.uid}
                    username={elem.username}
                    id={elem.id}
                    url={elem.url}
                    upload_time={elem.upload_time}
                    userId={user?.uid}
                    userType={user?.usertype}
                    voted={elem?.voted}
                    votes={elem?.votes}
                  />
                ))}
            </div>
          </>
        ) : (
          ""
        )}
        {eventid ? (
          <>
            <div className="heading">Images of {`${eventname}`}</div>
            <div className="image-container">
              {images?.map((elem) => (
                <Card
                  uid={elem.uid}
                  username={elem.username}
                  id={elem.id}
                  url={elem.url}
                  upload_time={elem.upload_time}
                  userId={user?.uid}
                  userType={user?.usertype}
                  voted={elem?.voted}
                  votes={elem?.votes}
                />
              ))}
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Gallery;
